<template>
  <div class="Confirmation">
    <Header msg='信息确认' />

    <div class="header-tips">当前报读信息，请认真核实</div>

    <div class="Confirmation-personal" v-if="paramsData.params">
      <!-- 推荐人 -->
      <div class="per-line" v-if="paramsData.paramsShow">
        <div class="flex flex-j-c-sb" style="color:#f44;font-weight:bold;" v-if="paramsData.paramsShow.inviter">
          <p class="inviterclass ellipsis">推荐人：{{paramsData.paramsShow.inviter.nickname}}(请认真核实)</p>
          <p></p>
        </div>
        <div class="flex flex-j-c-sb" style="color:#f44;font-weight:bold;" v-if="paramsData.paramsShow.inviter">
          <p class="inviterclass ellipsis">服务老师：{{paramsData.paramsShow.inviter.teacher_name || paramsData.paramsShow.inviter.teacher_name || '陈'}}老师</p>
          <p></p>
        </div>
      </div>
      <!-- 姓名 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>姓名</p>
          <p>{{paramsData.params.true_name}}</p>
        </div>
      </div>
      <!-- 身份证 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>身份证</p>
          <p>{{paramsData.params.idcard}}</p>
        </div>
      </div>
      <!-- 手机号码 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>手机号码</p>
          <p>{{paramsData.params.mobile}}</p>
        </div>
      </div>
      <!-- 城市 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>现住址</p>
          <p>{{paramsData.params.county}}</p>
        </div>
      </div>
      <!-- 详细地址 -->
      <!-- <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>详细地址</p>
          <p>{{paramsData.params.detailed_address}}</p>
        </div>
      </div> -->
      <!-- 紧急联系人姓名 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>紧急联系人姓名</p>
          <p>{{paramsData.params.crash_linkman}}</p>
        </div>
      </div>
      <!-- 紧急联系人姓名 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>紧急联系人电话号码</p>
          <p>{{paramsData.params.crash_mobile}}</p>
        </div>
      </div>
      <!-- 单位 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>单位</p>
          <p>{{paramsData.params.unit}}</p>
        </div>
      </div>
      <!-- 报读类型 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>报读类型</p>
          <p>{{paramsData.paramsShow.enrolment_name}}</p>
        </div>
      </div>
      <!-- 年级 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>年级</p>
          <p>{{paramsData.params.enrolment_year}}</p>
        </div>
      </div>
      <!-- 院校 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>院校</p>
          <p>{{paramsData.paramsShow.college_name}}</p>
        </div>
      </div>
      <!-- 层次 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>层次</p>
          <p>{{paramsData.paramsShow.arrangement_name}}</p>
        </div>
      </div>
      <!-- 专业 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>专业</p>
          <p>{{paramsData.paramsShow.major_name}}</p>
        </div>
      </div>
      <!-- 城市 -->
      <!-- <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <p>城市</p>
                    <p>{{paramsData.paramsShow.city_name}}</p>
                </div>
            </div> -->
      <!-- 服务校区 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <p>上课校区</p>
          <p>{{paramsData.paramsShow.servicCampus_name}}</p>
        </div>
      </div>
    </div>

    <div class="header-tips" style="color: #FABF01;">报读须知</div>

    <div class="Confirmation-tips flex flex-j-i-center">
      <p>1、报名成人高考须年满18周岁。</p>
      <p>2、报读高起专（专科）须具有高中（含中专、中技）或以上学历。</p>
      <p>3、报读专升本（本科）需为专科应届毕业生或者已取得大专或以上学历。</p>
      <p>4、报读需提供合法有效证件（包括但不限于本人证件照、身份证正反面复印件、毕业证复印件等）。</p>
      <p>5、若提供虚假证件，一经查实将取消报考资格。</p>
      <p>6、教材费缴纳后不予退还。</p>
    </div>

    <mt-button @click.native="isReady" size="large" :class="btnJudge ? 'bgColor':''">确认提交</mt-button>

  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { forderSubmit, getPreviewOrder, REQUEST_BASE, untieOrder, postUntieOrder } from '@/api'
import { Toast, MessageBox } from 'mint-ui'
import { Dialog } from 'vant'

export default {
  name: 'Confirmation',
  components: {
    Header,
  },
  data() {
    return {
      paramsData: {}, // 订单数据
      btnJudge: false, // 提交按钮
      pid: '', // 教师预报名订单号
      oid: '', // 绑定，解绑订单
    }
  },
  created() {
    this.pid = this.$route.query.previewId || ''
    this.oid = this.$route.query.orderId || ''
    if (this.pid) {
      // 教师预报名订单确认
      this.getPreview()
    } else if (this.oid) {
      // 订单绑定解绑
      this.getUntieOrder()
    } else {
      // 正常报名
      this.paramsData = JSON.parse(sessionStorage.getItem('_previewData'))
    }
    window.scrollTo(0, 0)
    // if (!this.paramsData) { Toast({message: '用户数据不存在，请重新报名~', className: 'iconfont icon-close', duration: 2000}); }
  },
  methods: {
    // 提交订单
    isReady() {
      if (this.oid) {
        this.reUntieOrder()
      } else {
        this.toSubmit(this.paramsData.params)
      }
    },
    /**
     * 提交订单接口
     * data 提交订单数据
     */
    toSubmit(data) {
      console.log(data)
      // return false;
      // alert(data.crash_linkman)
      if (this.btnJudge) return false
      this.btnJudge = true
      forderSubmit(data).then((res) => {
        if (res.code === 0) {
          sessionStorage.removeItem('_couponPay')
          Toast({ message: '订单确认成功', className: 'iconfont icon-dui', duration: 2000 })
          let params = { order_no: res.data.order_no, key: 'k' }
          sessionStorage.setItem('_needpayOrderNo', JSON.stringify(params))
          setTimeout(() => {
            this.$router.push({ name: 'Pay' })
          }, 2000)
        } else {
          if (res.code === 100) {
            MessageBox.alert(res.msg).then((action) => {
              this.$router.push({ name: 'Order' })
            })
          } else {
            Toast({ message: res.msg, className: 'iconfont icon-close', duration: 2000 })
          }

          // if (res.msg === "存在报名记录") {
          //   setTimeout(() => {
          //     this.$router.push({name:'Order'})
          //   }, 2000);
          // }
        }
        setTimeout(() => {
          this.btnJudge = false
        }, 2000)
      }).catch(() => {
        // 原来只有 then 没有 catch：提交失败（500 / 网络异常）时 btnJudge 永远停在 true，
        // 学员再点确认毫无反应，只能刷新页面重来。报错提示由 axios 拦截器统一弹过了，
        // 这里只负责把按钮解锁，让学员能直接重试。
        this.btnJudge = false
      })
    },
    // 获取教师预报名订单数据
    getPreview() {
      getPreviewOrder({ id: this.pid }).then((res) => {
        if (res.code === 0) {
          let obj = {}
          obj.params = {
            campus_id: res.data.campus_id,
            city_id: 1942,
            enrolment_id: res.data.enrolment_id,
            enrolment_year: res.data.enrolment_year,
            first_cat_id: res.data.first_cat_id,
            goods_id: res.data.goods_id,
            idcard: res.data.idcard,
            inviter_id: res.data.inviter_id,
            mobile: res.data.mobile,
            mobile_code: '',
            province_id: 1941,
            second_cat_id: res.data.second_cat_id,
            true_name: res.data.true_name,
            url: `${REQUEST_BASE()}/Order`,
            preview_id: this.pid,
            crash_linkman: res.data.crash_linkman,
            county: res.data.county,
            // detailed_address: res.data.detailed_address,
            crash_mobile: res.data.crash_mobile,
            unit: res.data.unit,
          }
          obj.paramsShow = {
            inviter: { nickname: res.data.inviter_name, teacher_name: res.data.teacher_name },
            enrolment_name: res.data.enrolment_name,
            college_name: res.data.first_name,
            arrangement_name: res.data.second_name,
            major_name: res.data.goods_name,
            servicCampus_name: res.data.campus,
          }
          this.paramsData = obj
        }
      })
    },
    // 获取即将绑定订单信息
    getUntieOrder() {
      untieOrder({ order_id: this.oid }).then((res) => {
        if (res.code === 0) {
          let obj = {}
          obj.params = {
            mobile: res.data.mobile,
            idcard: res.data.idcard,
            true_name: res.data.true_name,
            crash_linkman: res.data.crash_linkman,
            crash_mobile: res.data.crash_mobile,
            unit: res.data.unit,
            county: res.data.county,
            address: res.data.address,
            enrolment_year: res.data.enrolment_year,
          }
          obj.paramsShow = {
            enrolment_name: res.data.enrolment_name,
            college_name: res.data.first_name,
            arrangement_name: res.data.second_name,
            major_name: res.data.goods_name,
            servicCampus_name: res.data.campus,
          }
          this.paramsData = obj
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close', duration: 1500 })
          setTimeout(() => {
            this.$router.replace({ path: `/` })
          }, 1500)
        }
      })
    },
    // 绑定订单信息
    reUntieOrder() {
      Dialog.confirm({
        title: '绑定订单',
        message: '是否继续与该订单绑定？',
        confirmButtonColor: '#FAB201',
      })
        .then(() => {
          postUntieOrder({ order_id: this.oid }).then((res) => {
            if (res.code === 0) {
              this.$router.replace({ path: `/Order` })
            }
          })
        })
        .catch(() => {
          // on cancel
          console.log('cancel')
        })
    },
  },
}
</script>

<style scoped lang="less">
.Confirmation {
  min-height: 100%;
  padding: 0.54rem 0 0.5rem;
  font-size: 0.16rem;
  .header-tips {
    line-height: 0.37rem;
    text-align: left;
    margin-left: 0.16rem;
    color: #666666;
    font-size: 0.14rem;
  }
  .Confirmation-personal,
  .Confirmation-tips {
    padding: 0 0.16rem;
    background-color: white;
    font-size: 0.16rem;
    color: #333333;
    & > :last-child {
      border: none;
    }
  }
  .Confirmation-tips {
    flex-direction: column;
    text-align: left;
    color: #999999;
    padding: 0.16rem;
    font-size: 0.12rem;
    line-height: 0.18rem;
    width: 100%;
    word-wrap: break-word;
    word-break: break-all;
  }
  .inviterclass {
    width: 100%;
    text-align: left;
  }
}
</style>
